import { useCallback, useEffect, useState } from 'react';
import { CandidateListData } from '../../../shared/VolunteerApplicationServiceTypes';
import ProposerIcon from '../../../assets/images/proposer-icon.svg';
import ProposerIconGrey from '../../../assets/images/proposer-icon-grey.svg';
import WaitingApprover from '../../../assets/images/waiting-approver.svg';
import WaitingApproverGrey from '../../../assets/images/waiting-approver-grey.svg';
import ApprovedCandidates from '../../../assets/images/approved-candidates.svg';
import ApprovedCandidatesGrey from '../../../assets/images/approved-candidates-grey.svg';
import ProposerRecommendation from '../../../assets/images/proposer-recommendation.svg';
import ProposerRecommendationGrey from '../../../assets/images/proposer-recommendation-grey.svg';
import NotGoingForward from '../../../assets/images/not-going-forward.svg';
import NotGoingForwardGrey from '../../../assets/images/not-going-forward-grey.svg';
import { useTranslation } from 'react-i18next';
import { useScreeningDashboard } from './useScreeningDashboard';

export const useDashboardData = () => {
	const { t } = useTranslation();
	const { adminDashboardResponse } = useScreeningDashboard();
	const [dashboardData, setDashboardData] = useState<CandidateListData[]>([]);

	const getDashboardData = useCallback(() => {
		if (adminDashboardResponse) {
			const refinedResponseData: CandidateListData[] = [
				{
					id: 'overallCandidateApplications',
					count: adminDashboardResponse.overallCandidateApplication || 0,
					description: t('overallCandidateApplications'),
					imageSrc:
						(adminDashboardResponse.overallCandidateApplication || 0) > 0
							? ProposerIcon
							: ProposerIconGrey,
				},
				{
					id: 'proposerYetToBeAssigned',
					count: adminDashboardResponse.proposerYetToBeAssigned || 0,
					description: t('proposerYetToBeAssigned'),
					imageSrc:
						(adminDashboardResponse.proposerYetToBeAssigned || 0) > 0
							? WaitingApprover
							: WaitingApproverGrey,
				},
				{
					id: 'waitingForProposer',
					count: adminDashboardResponse.waitingForProposer || 0,
					description: t('waitingForProposerReview'),
					imageSrc:
						(adminDashboardResponse.waitingForProposer || 0) > 0
							? WaitingApprover
							: WaitingApproverGrey,
				},
				{
					id: 'proposerProvidedRecommendation',
					count: adminDashboardResponse.proposerProvidedRecommendation || 0,
					description: t('proposerProvidedRecommendation'),
					imageSrc:
						(adminDashboardResponse.proposerProvidedRecommendation || 0) > 0
							? ProposerRecommendation
							: ProposerRecommendationGrey,
				},
				{
					id: 'waitingForCareTeam',
					count: adminDashboardResponse.waitingForCareTeam || 0,
					description: t('waitingForCareTeamReview'),
					imageSrc:
						(adminDashboardResponse.waitingForCareTeam || 0) > 0
							? WaitingApprover
							: WaitingApproverGrey,
				},
				{
					id: 'approvedCandidates',
					count: adminDashboardResponse.approvedCandidates || 0,
					description: t('approvedCandidates'),
					imageSrc:
						(adminDashboardResponse.approvedCandidates || 0) > 0
							? ApprovedCandidates
							: ApprovedCandidatesGrey,
				},
				{
					id: 'notGoingForwardCandidates',
					count: adminDashboardResponse.notGoingForwardCandidates || 0,
					description: t('notGoingForwardCandidates'),
					imageSrc:
						(adminDashboardResponse.notGoingForwardCandidates || 0) > 0
							? NotGoingForward
							: NotGoingForwardGrey,
				},
			];
			setDashboardData(refinedResponseData);
		}
	}, [adminDashboardResponse, t]);

	useEffect(() => {
		void getDashboardData();
	}, [getDashboardData]);

	return {
		dashboardData,
		getDashboardData,
	};
};
